module.exports = __webpack_public_path__ + "static/3-93f33eb92a1fb482f0a456fd1bd03540.jpg";